import React, { useState, lazy } from 'react';
import { MapPin, Phone, Mail, Instagram, Clock, Send } from 'lucide-react';
export function Contact() {
  return <div className="w-full" data-id="element-336" data-mp="1brkg7hnjy3fa">
      <SplitInfo data-id="element-337" data-mp="1buge55zegs3q" />
      <ContactForm data-id="element-338" data-mp="1qp330ego66k3" />
    </div>;
}
/* ---------- 1. SPLIT INFO + MAP ---------- */
function SplitInfo() {
  return <section className="bg-white" data-id="element-339" data-mp="1lq0blwtm3yul">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[680px]" data-id="element-340" data-mp="1lr1lhxyw6faq">
        {/* Left — info */}
        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-20 bg-white relative overflow-hidden" data-id="element-341" data-mp="xyl0bejuy777">
          {/* Red speed streak accent */}
          <div className="absolute -top-1 left-0 w-28 h-1.5 bg-reach-red" data-id="element-342" data-mp="17raa84zrfd0f" />

          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4" data-id="element-343" data-mp="12zihbnt4sv74">
            Visit · Call · Train
          </p>
          <h1 className="font-bebas text-reach-black text-6xl md:text-7xl lg:text-[88px] leading-[0.9] tracking-wide mb-8" data-id="element-344" data-mp="f7v05xlo8yi1">
            Where to
            <br data-id="element-345" data-mp="15g8b4ypf30pb" />
            Find Us
          </h1>

          <div className="w-12 h-1 bg-reach-red mb-8" data-id="element-346" data-mp="15dm6p7xtp1bb" />

          {/* New Portrait Card */}
          <div className="mb-10 bg-reach-black p-6 rounded-[4px] max-w-[248px]" data-id="element-347" data-mp="19exncnypyc7d">
            <img src="https://cdn.magicpatterns.com/uploads/nS7CAkLSbDsg56k6ey7c7u/FernandoB_Dec2022-42-2.jpg" alt="Coach Fernando Beltran portrait" className="w-[200px] h-[200px] object-cover object-top rounded-[4px] mb-5" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} data-id="element-348" data-mp="1e8a98qc0k4wf" />
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.2em] font-semibold mb-2" data-id="element-349" data-mp="vfo8brm91o4z">
              WHO READS THIS
            </p>
            <p className="font-inter text-white text-[18px] leading-snug" data-id="element-350" data-mp="26wo97bmnxbam">
              Coach Fernando reads every message and personally responds.
            </p>
          </div>

          <ul className="space-y-6" data-id="element-351" data-mp="2bxc1e0mmny6f">
            <li className="flex items-start gap-4" data-id="element-352" data-mp="1m6kd505v3w8u">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-353" data-mp="1m96kozsr6br2">
                <MapPin size={18} className="text-reach-red" data-id="element-354" data-mp="1hamzx2pwb60a" />
              </div>
              <a href="https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070" target="_blank" rel="noopener noreferrer" className="group" data-id="element-355" data-mp="1w3goddn5awh3">
                <p className="font-inter text-reach-black text-xl md:text-2xl font-semibold leading-snug group-hover:text-reach-red transition-colors" data-id="element-356" data-mp="yhsoujve7y1c">
                  6051 Alma Rd · McKinney, TX 75070
                </p>
                <p className="font-inter text-sm text-reach-black/60 mt-1 uppercase tracking-wider" data-id="element-357" data-mp="18fozzbobyszg">
                  Inside INPOWERiQ Performance Center
                </p>
              </a>
            </li>

            <li className="flex items-center gap-4" data-id="element-358" data-mp="fq8deune66b5">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-359" data-mp="fpgou3s7p8ud">
                <Phone size={18} className="text-reach-red" data-id="element-360" data-mp="2w5d39dy601m4" />
              </div>
              <a href="tel:7089804666" className="font-inter text-reach-black text-lg md:text-xl hover:text-reach-red transition-colors" data-id="element-361" data-mp="2w7fzifpwuqza">
                (708) 980-4666
              </a>
            </li>

            <li className="flex items-center gap-4" data-id="element-362" data-mp="3a660i6fupasx">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-363" data-mp="3a3bi0kgee025">
                <Mail size={18} className="text-reach-red" data-id="element-364" data-mp="314g8aye5a7u3" />
              </div>
              <a href="mailto:Fernando@reachperformancehq.com" className="font-inter text-reach-black text-base md:text-lg hover:text-reach-red transition-colors break-all" data-id="element-365" data-mp="316iwdcvqlqw6">
                Fernando@reachperformancehq.com
              </a>
            </li>

            <li className="flex items-start gap-4" data-id="element-366" data-mp="1tojm3xk1mao3">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-367" data-mp="29z2hz611fkm6">
                <Clock size={18} className="text-reach-red" data-id="element-368" data-mp="256ivtkoabh5r" />
              </div>
              <div data-id="element-369" data-mp="207g2gxho2zdm">
                <p className="font-inter text-reach-black text-lg font-semibold" data-id="element-370" data-mp="208ze2asdom92">
                  Mon – Fri
                </p>
                <p className="font-inter text-sm text-reach-black/60 uppercase tracking-wider mt-0.5" data-id="element-371" data-mp="1v71tnd88rlej">
                  See class schedule
                </p>
              </div>
            </li>

            <li className="flex items-center gap-4" data-id="element-372" data-mp="2nvpej7p2w8rk">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-373" data-mp="2ixny6uj1enjs">
                <Instagram size={18} className="text-reach-red" data-id="element-374" data-mp="2ewc5gg4v9m7d" />
              </div>
              <a href="https://instagram.com/reachperformancehq" target="_blank" rel="noopener noreferrer" className="font-inter text-reach-black text-lg hover:text-reach-red transition-colors" data-id="element-375" data-mp="17jshhhchi6qg">
                @reachperformancehq
              </a>
            </li>
          </ul>
        </div>

        {/* Right — map */}
        <div className="relative min-h-[400px] lg:min-h-0 bg-reach-black" data-id="element-376" data-mp="3o5qg7nbj4byo">
          <iframe title="Reach Performance location at 6051 Alma Rd, McKinney, TX" src="https://www.google.com/maps?q=6051%20Alma%20Rd%2C%20McKinney%2C%20TX%2075070&t=&z=15&ie=UTF8&iwloc=&output=embed" className="absolute inset-0 w-full h-full grayscale contrast-110" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-377" data-mp="3swfb7cmf3r2k" />
          {/* Subtle red accent bar */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-reach-red z-10 pointer-events-none" data-id="element-378" data-mp="fovrrcvhau44" />
        </div>
      </div>
    </section>;
}
/* ---------- 2. CONTACT FORM ---------- */
type Status = 'idle' | 'submitting' | 'success' | 'error';
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xgoqybwb';
function ContactForm() {
  const [status, setStatus] = useState<Status>('idle');
  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    setStatus('submitting');
    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        form.reset();
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }
  const resetForm = () => setStatus('idle');
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-379" data-mp="ledjij0ylizj">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-380" data-mp="lbhnx1cl36e9">
        <div className="text-center mb-10" data-id="element-381" data-mp="150fcvpki23i0">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-382" data-mp="19y756kp23rmq">
            Get In Touch
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-383" data-mp="uzwp4jpte2ut">
            Have a Question?
          </h2>
          <p className="font-inter text-reach-black/70 text-base md:text-lg mt-4 max-w-xl mx-auto" data-id="element-384" data-mp="zy6lgxn9z9i0">
            Send us a note. Coach Fernando reads every message.
          </p>
        </div>

        <div className="bg-white rounded-[4px] p-6 md:p-10 border-t-4 border-reach-red" data-id="element-385" data-mp="r0nttaf4lwx5">
          {status === 'success' ? <div className="text-center py-10" data-id="element-386" data-mp="h9jeuapgac2b">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-387" data-mp="habblousafu6">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-388" data-mp="3aaac8alx6e6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-389" data-mp="ir8lh61dfrij" />
                </svg>
              </div>
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide mb-3" data-id="element-390" data-mp="8t2i0jzx2dbk">
                Thanks, your message is in
              </h3>
              <p className="font-inter text-reach-black/75 max-w-md mx-auto mb-6" data-id="element-391" data-mp="1k5cj26ifn8">
                Coach Fernando typically responds within 24 hours.
              </p>
              <button type="button" onClick={resetForm} className="inline-flex items-center justify-center font-inter font-semibold text-sm uppercase tracking-wider px-5 py-2.5 border-2 border-reach-black text-reach-black rounded hover:bg-reach-black hover:text-white transition-colors" data-id="element-392" data-mp="3r5h71u5h7i17">
                Send another
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-393" data-mp="1wr3cs675ij0f">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-394" data-mp="1wtg1r3bbttmz">
                <Field id="name" label="Name" required type="text" placeholder="Your name" data-id="element-395" data-mp="21rrcdg9g4869" />
                <Field id="email" label="Email" required type="email" placeholder="you@example.com" data-id="element-396" data-mp="1933k30qa4ij7" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-397" data-mp="1ixvl6ej2lniq">
                <Field id="phone" label="Phone" type="tel" placeholder="(555) 123-4567" data-id="element-398" data-mp="1nrgkc9wegnji" />
                <div data-id="element-399" data-mp="v9m1pj9bxbur">
                  <label htmlFor="age" className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-400" data-mp="v92tiu9he1tx">
                    Athlete's Age
                  </label>
                  <select id="age" name="age" className="w-full px-4 py-3 min-h-[48px] bg-white border-2 border-black/15 rounded font-inter text-base text-reach-black focus:outline-none focus:border-reach-red transition-colors" data-id="element-401" data-mp="yw1kyuno67so">
                    <option value="" data-id="element-402" data-mp="b5nwfe4amr2u">Select age</option>
                    <option value="8-10" data-id="element-403" data-mp="b437c40r00cd">8–10 (Youth)</option>
                    <option value="11-13" data-id="element-404" data-mp="g48ylj33vktx">11–13 (Middle School)</option>
                    <option value="14-18" data-id="element-405" data-mp="kwinqwwecgv5">14–18 (High School)</option>
                    <option value="other" data-id="element-406" data-mp="kxtriwpudom9">Other / Multiple</option>
                    <option value="pro-collegiate" data-id="element-407" data-mp="3jlhh855nqopp">Pro / Collegiate</option>
                  </select>
                </div>
              </div>

              <div data-id="element-408" data-mp="25pz9mbvfhr2e">
                <label htmlFor="message" className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-409" data-mp="25qhfm07w7jni">
                  Message
                </label>
                <textarea id="message" name="message" required rows={5} placeholder="What can we help with?" className="w-full px-4 py-3 bg-white border-2 border-black/15 rounded font-inter text-base text-reach-black focus:outline-none focus:border-reach-red transition-colors resize-none" data-id="element-410" data-mp="1wngbg52l82mh" />
              </div>

              <button type="submit" disabled={status === 'submitting'} className="btn-primary w-full sm:w-auto disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-411" data-mp="18zyqasdtw2sh">
                <Send size={16} className="mr-2" data-id="element-412" data-mp="z1978wa74can" />
                {status === 'submitting' ? 'Sending' : 'Send'}
              </button>

              {status === 'error' && <p className="font-inter text-sm text-red-600" data-id="element-413" data-mp="ucqblhlb9fbr">
                  Something went wrong. Please email
                  Fernando@reachperformancehq.com or call 708-980-4666.
                </p>}
            </form>}
        </div>

        <p className="text-center font-inter text-xs uppercase tracking-[0.25em] text-reach-black/50 mt-8" data-id="element-414" data-mp="kgwoj49yu3fq">
          We typically respond within 24 hours
        </p>
      </div>
    </section>;
}
function Field({
  id,
  label,
  type,
  placeholder,
  required
}: {
  id: string;
  label: string;
  type: string;
  placeholder?: string;
  required?: boolean;
}) {
  return <div data-id="element-415" data-mp="13cdanwqki91n">
      <label htmlFor={id} className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-416" data-mp="13c4vfy6z2rna">
        {label}
        {required && <span className="text-reach-red ml-1" data-id="element-417" data-mp="1vusfdaa8g0ms">*</span>}
      </label>
      <input id={id} name={id} type={type} placeholder={placeholder} required={required} className="w-full px-4 py-3 min-h-[48px] bg-white border-2 border-black/15 rounded font-inter text-base text-reach-black placeholder:text-reach-black/40 focus:outline-none focus:border-reach-red transition-colors" data-id="element-418" data-mp="3gk4h68ktspsp" />
    </div>;
}